import { AuthConfig, OAuthStorage } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';

export const AUTH_CODE_FLOW_CONFIG: AuthConfig = {
  issuer: environment.loginCidadao.issuer,
  redirectUri: environment.loginCidadao.redirectUri,
  clientId: environment.loginCidadao.clientId,
  responseType: 'code',
  scope: environment.loginCidadao.scope,
  showDebugInformation: false,
  requireHttps: false
};

export const AUTH_PROVIDER = {
  provide: OAuthStorage,
  useValue: localStorage
};
